import {
  US,
  GB,
  FR,
  DE,
  IN,
  AU,
  AT,
  BE,
  CA,
  DK,
  FI,
  IS,
  IE,
  IT,
  JP,
  MX,
  NL,
  NZ,
  NO,
  PL,
  SE,
  SG,
  KR,
  ES,
  CH,
  TW,
} from "country-flag-icons/react/3x2"

const flags = {
  US,
  AU,
  AT,
  BE,
  CA,
  DK,
  FI,
  FR,
  DE,
  IS,
  IE,
  IT,
  JP,
  MX,
  NL,
  NZ,
  NO,
  PL,
  SE,
  SG,
  KR,
  ES,
  CH,
  TW,
  GB,
  IN,
}

// export const countryNames = {
//   US: "United States",
//   GB: "United Kingdom",
//   FR: "France",
//   DE: "Germany",
//   IN: "India",
// }
export default flags
